import React from 'react'
import {
  Typography,
  Button,
  Box,
  Container,
  Grid,
  Stack,
  Paper,
  Card,
  CardContent,
  Chip,
} from "@mui/material";
import FormatQuoteIcon from "@mui/icons-material/FormatQuote";
import StarIcon from "@mui/icons-material/Star";

const testimonials = [
  {
    name: "Rajesh Kumar",
    role: "Owner, Spice Garden Restaurant",
    img: "https://randomuser.me/api/portraits/men/32.jpg",
    quote: "Restaurantwala transformed our business. QR ordering increased our table turnover by 40%!",
    rating: 5,
  },
  {
    name: "Priya Sharma",
    role: "Manager, The Coffee House",
    img: "https://randomuser.me/api/portraits/women/44.jpg",
    quote: "The WhatsApp integration is a game-changer. We never miss an order now.",
    rating: 5,
  },
  {
    name: "Amit Patel",
    role: "Owner, Urban Bites",
    img: "https://randomuser.me/api/portraits/men/45.jpg",
    quote: "Staff management and real-time dashboard made operations so much easier.",
    rating: 5,
  },
  {
    name: "Sneha Reddy",
    role: "Owner, GreenLeaf Cafe",
    img: "https://randomuser.me/api/portraits/women/65.jpg",
    quote: "Our customers love the digital menu. Stock tracking helps us manage inventory better.",
    rating: 5,
  },
];

const Testimonials = () => {
  return (
     <Box sx={{ py: 12, bgcolor: "#fff" }}>
        <Container maxWidth="xl">
          <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
            <Typography
              sx={{
                color: "#49d75b",
                fontWeight: 700,
                fontSize: "15px",
                letterSpacing: "1px",
              }}
            >
              — What Our Clients Say
            </Typography>
          </Box>

          <Typography
            sx={{
              textAlign: "center",
              fontSize: { xs: "2.3rem", md: "3.5rem" },
              fontWeight: 900,
              color: "#111",
              mb: 6,
              lineHeight: 1.2,
            }}
          >
            Trusted by{" "}
            <Box component="span" sx={{ color: "#49d75b" }}>
              Restaurant Owners
            </Box>
          </Typography>

          <Box
            sx={{
              display: "flex",
              gap: 3,
              pb: 4,
              overflowX: "auto",
              "&::-webkit-scrollbar": { height: "6px" },
              "&::-webkit-scrollbar-thumb": { bgcolor: "#ccc", borderRadius: "4px" },
            }}
          >
            {testimonials.map((item, index) => (
              <Paper
                elevation={0}
                key={index}
                sx={{
                  bgcolor: "#fff",
                  borderRadius: "24px",
                  p: 4,
                  border: "1px solid #ececec",
                  transition: "0.3s",
                  flex: { xs: "0 0 280px", sm: "0 0 340px", md: "0 0 360px" },
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  "&:hover": {
                    transform: "translateY(-6px)",
                    boxShadow: "0 25px 55px rgba(0,0,0,0.06)",
                  },
                }}
              >
                <Box>
                  <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", mb: 3 }}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                      <Box
                        component="img"
                        src={item.img}
                        alt={item.name}
                        sx={{
                          width: 55,
                          height: 55,
                          borderRadius: "50%",
                          objectFit: "cover",
                        }}
                      />
                      <Box>
                        <Typography sx={{ fontWeight: 800, color: "#111", fontSize: "1rem" }}>
                          {item.name}
                        </Typography>
                        <Typography sx={{ color: "#888", fontSize: "13px" }}>{item.role}</Typography>
                      </Box>
                    </Box>
                    <Box
                      sx={{
                        width: 42,
                        height: 42,
                        borderRadius: "50%",
                        bgcolor: "#f0faf0",
                        display: "grid",
                        placeItems: "center",
                        color: "#49d75b",
                      }}
                    >
                      <FormatQuoteIcon sx={{ fontSize: 22 }} />
                    </Box>
                  </Box>
                  <Typography sx={{ color: "#555", lineHeight: 1.7, fontSize: "14px" }}>
                    "{item.quote}"
                  </Typography>
                </Box>
                <Box sx={{ mt: 4 }}>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                    {[...Array(item.rating)].map((_, starIndex) => (
                      <StarIcon key={starIndex} sx={{ color: "#49d75b", fontSize: 16 }} />
                    ))}
                    <Typography sx={{ ml: 0.5, fontWeight: 700, color: "#111", fontSize: "14px" }}>
                      {item.rating}.0
                    </Typography>
                  </Box>
                </Box>
              </Paper>
            ))}
          </Box>
        </Container>
      </Box>
  )
}

export default Testimonials